<template>
  <div>
    <div v-if="carouselType === 3">
      <div v-show="isBlogssReady">
        <div
          :class="[
            isMobileLayout ? 'container pt-36' : 'provider-container pt-40',
          ]"
        >
          <mq-layout
            :mq="['xs', 'sm', 'md']"
            :class="[isMobileLayout ? 'mobile-layout' : '']"
          >
            <div
              class="provider-infos__position provider-infos__position--mobile"
            >
              <h2 class="text-uppercase">
                {{ title }}
              </h2>

              <el-image
                class="provider-image__dimension mt-20"
                :src="thumbnail"
                :fit="'cover'"
              />
            </div>

            <h4 class="provider-name mt-40 text-left" style="height: 32px">
              {{ relatedProviders }}
            </h4>

            <!-- eslint-disable-next-line -->
            <Scrollable
              :horizontal="false"
              :lightTheme="true"
              class="paragraph1 mt-5 provider-carousel-content provider-carousel-content__mobile"
              v-html="content"
              style="color: white"
            />

            <div class="flex mt-20" style="align-items: center">
              <div class="text-left">
                <el-button
                  type="primary"
                  class="button-dimension"
                  @click="goTo(`blogs/${link}`)"
                  style="font-size: 14px; width: 122px"
                >
                  {{ ctaReadMore }}
                </el-button>
              </div>
              <div>
                <router-link
                  :to="providersView"
                  class="el-link el-link--success is-underline ml-20"
                  style="font-size: 14px"
                >
                  <span class="el-link--inner">
                    {{ ctaAllProviders }}
                  </span>
                </router-link>
              </div>
            </div>
          </mq-layout>
          <mq-layout
            mq="lg+"
            class="container"
            :style="{ width: $mq === 'lg' ? '920px' : '940px' }"
          >
            <div class="provider-infos__position">
              <el-image
                class="provider-image__dimension"
                :src="thumbnail"
                :fit="'cover'"
              />
              <div class="ml-75" style="width: 520px">
                <h2 class="text-uppercase text-left blog-title" style="height: 92px">
                  {{ title }}
                </h2>

                <h4 class="provider-name mt-36 text-left" style="height: 32px">
                  {{ relatedProviders }}
                </h4>

                <!-- eslint-disable-next-line -->
                <Scrollable
                  :horizontal="false"
                  :lightTheme="true"
                  class="paragraph1 mt provider-carousel-content"
                >
                  <p v-html="content"></p>
                </Scrollable>

                <div class="flex mt-26" style="align-items: center">
                  <div class="text-left">
                    <el-button
                      type="primary"
                      class="button-dimension pt-10"
                      style="width: 100%; height: 40px"
                      @click="goTo(`blogs/${link}`)"
                    >
                      {{ ctaReadMore }}
                    </el-button>
                  </div>
                  <div>
                    <router-link
                      :to="providersView"
                      class="el-link el-link--success is-underline ml-20"
                    >
                      <span class="el-link--inner">
                        {{ ctaAllProviders }}
                      </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </mq-layout>
        </div>
      </div>
    </div>
    <div v-else-if="carouselType === 2 && isMobileLayout">
      <div v-for="(blog, i) in blogs" :key="i" class="mb-15">
        <BlogCard
          :blog="blog"
          :is-carousel="true"
          :carousel-type="carouselType"
        />
      </div>
    </div>
    <div v-else>
      <el-carousel
        id="carousel"
        class="carousel"
        :interval="0"
        indicator-position="none"
        :height="carouselHeight"
        :arrow="arrow"
        direction="horizontal"
      >
        <el-carousel-item
          v-for="(blogGroup, i) in blogGroups"
          id="carousel-item"
          :key="i"
        >
          <div style="display: flex; gap: 30px;">
            <el-col
              v-for="blog in blogGroup"
              :key="blog.id"
              :span="isMobileLayout ? 24 : 8"
            >
              <BlogCard
                :blog="blog"
                :is-carousel="true"
                :carousel-type="carouselType"
              />
            </el-col>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { forEach, get, isEmpty } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";

import Scrollable from "@/components/scrollable.vue";
import BlogCard from "@/views/blog/components/blog-card.vue";
import imgDefault from "@/assets/images/provider/provider-desktop.svg";
import getRandomInt from "../../../mixins/getRandomInt";
import goTo from "../../../mixins/goTo";

export default {
  mixins: [getRandomInt, goTo],
  components: {
    BlogCard,
    Scrollable,
  },
  props: {
    blogs: {
      type: Array,
      default: () => [],
    },
    carouselType: {
      type: Number,
      default: 0,
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
    isMounted: {
      type: Boolean,
      default: false,
    },
    arrow: {
      type: String,
      default: "hover",
    },
  },
  data() {
    return {
      images: {
        providerDefault: {
          src: imgDefault,
        },
      },
    };
  },

  computed: {
    blogGroups() {
      const groups = [];
      let group = [];
      forEach(this.blogs, (p) => {
        group.push(p);
        if (group.length > (this.isMobileLayout ? 0 : 2)) {
          groups.push({
            ...group,
          });
          group = [];
        }
      });

      if (group.length > 0) {
        groups.push({
          ...group,
        });
      }

      return groups;
    },
    relatedProviders() {
      var author = '';
      if(get(this.selectedBlog, 'relatedProviders[0].name') != undefined){
         author = `${get(this.selectedBlog.relatedProviders[0], "name")} `;
      }
      return author != null ? author : "";
    },
    selectedBlog() {
      return (
        !isEmpty(this.blogs) &&
        this.blogs.length > this.selectedIndex &&
        this.blogs[this.selectedIndex]
      );
    },
    ctaReadMore() {
      return this.$i18n.t("blogs.blogCarousel.cta.readMore");
    },
    ctaAllProviders() {
      return this.$i18n.t("blogs.blogCarousel.cta.allProviders");
    },
    thumbnail() {
      const thumbnail = get(this.selectedBlog, "mainImage.link");

      if (thumbnail == null) {
        return this.images.providerDefault.src;
      }

      return thumbnail;
    },
    producerName() {
      return `${get(this.selectedBlog, "user.firstName")} ${get(
        this.selectedBlog,
        "user.lastName"
      )}`;
    },
    title() {
      return get(this.selectedBlog, "title", "");
    },
    content() {
      return get(this.selectedBlog, "description", "");
    },
    link() {
      return get(this.selectedBlog, "id", "");
    },
    isBlogssReady() {
      return !isEmpty(this.blogs);
    },
    providersView() {
      return {
        name: "blogs",
        params: {},
        query: {
          type: "PROCUCER",
        },
      };
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    carouselHeight() {
      if (
        (this.isMobileLayout && this.carouselType === 2) ||
        this.carouselType === 1
      ) {
        return "400px";
      }

      return "280px";
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";
$provider-image-width-sm: 300px;
$provider-image-height-sm: 300px;
$provider-image-width-lg: 337px;
$provider-image-height-lg: 348px;

.el-carousel__item {
  background-color: $color-background;
}
.carousel {
  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $container-max-width-md;
    margin-left: auto;
    margin-right: auto;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $container-max-width-lg;
    margin-left: auto;
    margin-right: auto;
  }
}

.provider-container {
  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $container-max-width-md;
    margin-left: auto;
    margin-right: auto;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $container-max-width-lg;
    margin-left: auto;
    margin-right: auto;
  }
}
.button-dimension {
  height: 35px;
}
.provider-image__dimension {
  // sm -
  @media screen and (max-width: $media-md) {
    height: $provider-image-height-sm;
  }
  // md +
  @media screen and (min-width: $media-md) {
    height: $provider-image-height-lg;
    width: $provider-image-width-lg;
  }
}
.provider-infos__position {
  display: flex;

  & div {
    & h2 {
      font-family: $font-family-futura-std;
      letter-spacing: 0.25px;
      color: $color-on-primary;

      // sm -
      @media screen and (max-width: $media-md) {
        line-height: 36px;
      }
      // md +
      @media screen and (min-width: $media-md) {
        line-height: normal;
      }
    }
    & div {
      color: $color-on-background-area1;
    }
  }
}
.provider-infos__position--mobile {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;

  & h2 {
    font-family: $font-family-futura-std;
    letter-spacing: 0.25px;
    color: $color-on-primary;

    // sm -
    @media screen and (max-width: $media-md) {
      line-height: 36px;
    }
    // md +
    @media screen and (min-width: $media-md) {
      line-height: normal;
    }
  }
  & div {
    color: $color-on-background-area1;
  }
}
.provider-name {
  font-family: $font-family-futura-std;
  letter-spacing: 0.25px;
  color: $color-on-primary;
}
.provider-carousel-content {
  color: $color-on-primary !important;
  width: 410px;
  height: 100px;
  line-height: 22px;
  text-align: left;

  & p {
    color: $color-on-primary !important;
    line-height: 22px;
    background-color: transparent !important;
  }

  & p span {
    color: $color-on-primary !important;
    line-height: 22px;
    background-color: transparent !important;
  }
}
.provider-carousel-content__mobile {
  line-height: 20px;

  color: $color-on-primary !important;
  width: $provider-image-width-sm;
  line-height: 20px;

  & p {
    color: $color-on-primary !important;
    line-height: 20px;
  }

  & p span {
    color: $color-on-primary !important;
    line-height: 20px;
  }
}
.mobile-layout {
  width: $provider-image-width-sm;
  margin-right: auto;
  margin-left: auto;
}
</style>
